module.exports = __webpack_public_path__ + "static/img/yue@2x.c191172b.png";